import { React, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/sidebar.scss';
import Logout from './Logout';

const Sidebar = () => {
    const location = useLocation();
    const [isPolosOpen, setIsPolosOpen] = useState(false);
    const [isRegistrosOpen, setIsRegistrosOpen] = useState(false);
    const [isRelatoriosOpen, setIsRelatoriosOpen] = useState(false);

    // Efeito para definir o estado do dropdown baseado na rota
    useEffect(() => {
        if (location.pathname.startsWith('/alunos-polo') || location.pathname.startsWith('/cursos-polo')) {
            setIsPolosOpen(true);
        } else {
            setIsPolosOpen(false);
        }

        if (location.pathname.startsWith('/ofertas') || location.pathname.startsWith('/atualizacao-cadastral')) {
            setIsRegistrosOpen(true);
        } else {
            setIsRegistrosOpen(false);
        }
        if (location.pathname.startsWith('/relatorio-mais-ofertados') || location.pathname.startsWith('/relatorio-cursos') || location.pathname.startsWith('/relatorio-status-cursos') || location.pathname.startsWith('/relatorio-ingressos')) {
            setIsRelatoriosOpen(true);
        } else {
            setIsRelatoriosOpen(false);
        }
    }, [location]);

    const togglePolosDropdown = () => {
        setIsPolosOpen(!isPolosOpen);
        setIsRelatoriosOpen(false); // Fecha o dropdown de Polos se estiver aberto
        setIsRegistrosOpen(false); // Fecha o dropdown de Polos se estiver aberto
    };
    
    const toggleRegistrosDropdown = () => {
        setIsRegistrosOpen(!isRegistrosOpen);
        setIsRelatoriosOpen(false); // Fecha o dropdown de Polos se estiver aberto
        setIsPolosOpen(false); // Fecha o dropdown de Registros se estiver aberto
    };
    
    const toggleRelatoriosDropdown = () => {
        setIsRelatoriosOpen(!isRelatoriosOpen);
        setIsRegistrosOpen(false); // Fecha o dropdown de Polos se estiver aberto
        setIsPolosOpen(false); // Fecha o dropdown de Registros se estiver aberto
    };

    return (
        <div className="sidebar">
            <nav className="nav flex-column">
                <Link to={"/dashboard"} className="nav-Link">
                    <span className="icon">
                        <i className="bi bi-grid"></i>
                    </span>
                    <span className="description">Dashboard</span>
                </Link>
                <div className="nav-Link" onClick={togglePolosDropdown}>
                    <span className="icon">
                        <i className="bi bi-box"></i>
                    </span>
                    <span className="description">Polos</span>
                </div>
                {isPolosOpen && (
                    <div className="dropdown-content">
                        <Link to="/alunos-polo" className="dropdown-item">
                            <span className="icon">
                                <i className="bi bi-clipboard-check"></i>
                            </span>
                            <span className="description">Alunos Por Polo</span>
                        </Link>
                        <Link to="/cursos-polo" className="dropdown-item">
                            <span className="icon">
                                <i className="bi bi-book"></i>
                            </span>
                            <span className="description">Cursos Por Polo</span>
                        </Link>
                    </div>
                )}
                <div className="nav-Link" onClick={toggleRegistrosDropdown}>
                    <span className="icon">
                        <i className="bi bi-app-indicator"></i>
                    </span>
                    <span className="description">Registros</span>
                </div>
                {isRegistrosOpen && (
                    <div className="dropdown-content">
                        <Link to="/ofertas" className="dropdown-item">
                            <span className="icon">
                                <i className="bi bi-card-checklist"></i>
                            </span>
                            <span className="description">Ofertas</span>
                        </Link>
                        <Link to="/atualizacao-cadastral" className="dropdown-item">
                            <span className="icon">
                                <i className="bi bi-person-lines-fill"></i>
                            </span>
                            <span className="description">Atualização Cadastral</span>
                        </Link>
                    </div>
                )}
                <div className="nav-Link" onClick={toggleRelatoriosDropdown}>
                    <span className="icon">
                        <i className="bi bi-clipboard-data"></i>
                    </span>
                    <span className="description">Relatorios</span>
                </div>
                {isRelatoriosOpen && (
                    <div className="dropdown-content">
                        <Link to="/relatorio-ingressos" className="dropdown-item">
                            <span className="icon">
                                <i className="bi bi-graph-up-arrow"></i>
                            </span>
                            <span className="description">Alunos Ingressos</span>
                        </Link>
                        <Link to="/relatorio-cursos" className="dropdown-item">
                            <span className="icon">
                                <i className="bi bi-person-square"></i>
                            </span>
                            <span className="description">Cursos</span>
                        </Link>
                        <Link to="/relatorio-mais-ofertados" className="dropdown-item">
                            <span className="icon">
                                <i className="bi bi-activity"></i>
                            </span>
                            <span className="description">Mais Ofertados</span>
                        </Link>
                        <Link to="/relatorio-status-cursos" className="dropdown-item">
                            <span className="icon">
                                <i className="bi bi-kanban"></i>
                            </span>
                            <span className="description">Status de Cursos</span>
                        </Link>
                    </div>
                )}
                <Link to={"/anexos"} className="nav-Link">
                    <span className="icon">
                        <i className="bi bi-file-earmark-pdf"></i>
                    </span>
                    <span className="description">Anexos</span>
                </Link>
            </nav>
            <Logout/>
        </div>
    );
};

export default Sidebar;
